import NotificationActions from '../../actions/NotificationActions';
import RoutingActions from '../../actions/RoutingActions';
import GuestListActions from '../../actions/GuestListActions';

import UserStore from '../../stores/UserStore';

import AjaxPromises from '../../utils/AjaxPromises';
import { endPoints as EndPoints } from '../../constants/PosConstants';

import Input from '../form/input/Input.react';
import InputDOB from '../form/input/InputDOB.react';
import DropdownProfile from '../profile/view/DropdownProfile.react';

import PageHeader from '../form/layout/PageHeader.react';
import PageRow from '../form/layout/PageRow.react';
import DD from '../form/dropdown/DD.react';
import UserActions from '../../actions/UserActions';

class NewAnonProfile extends React.Component {

    constructor(props) {
        super(props);

        // TODO :: camel case
        this.state = {
            loading         : false,
            patient_type    : 'Medical',
            status          : 'Active',
            customerTypes: [],
            customerTypeId: '',
        };

        this.createNewProfile = this.createNewProfile.bind(this);
        this.validate = this.validate.bind(this);
        this.setCustomerTypes = this.setCustomerTypes.bind(this);
    }

    componentDidMount() {
        this.setCustomerTypes();
        UserStore.addChangeListener(this.setCustomerTypes);
    }

    componentWillUnmount() {
        UserStore.removeChangeListener(this.setCustomerTypes);
    }

    setCustomerTypes() {
        var userData = UserStore.getState();
        var selectedLocation = userData.selectedLocation;

        var customerTypes = userData.customerTypes.reduce((acc, t) => {
            if (t.IsRetail && !t.IsMedical) {
                acc.push({ title: t.CustomerType, option: t.CustomerTypeId });
            }
            return acc;
        }, [{ title: '-', option: ''}]);

        if (selectedLocation && selectedLocation.DefaultCustomerTypeId) {
            this.setState({ customerTypeId: selectedLocation.DefaultCustomerTypeId });
        } else {
            if (customerTypes.length === 2) {
                this.setState({ customerTypeId : customerTypes[1].option });
            }
        }

        this.setState({ customerTypes });        
    }    

    createNewProfile() {
        var self = this;
        const selectedLocation = UserStore.getState().selectedLocation;

        if (!this.validate()) {
            return;
        }

        if (this.state.loading) {
            return;
        }

        if (selectedLocation.BlockMinorsFromCheckInFF && UserActions.checkAnonymousTransactionMinorStatus(this.state.dob, selectedLocation.DefaultRecMinorAge)) {

            NotificationActions.error(`Patient is under the age of ${selectedLocation.DefaultRecMinorAge}. You cannot proceed`);
            return;
        }

        this.setState({ loading : true }, () => {

            var self = this;

            if (!UserStore.getState().selectedRegister) {
                NotificationActions.addNotification({body : 'Select register to continue', type : 'alert' });
                return;
            }

            var formData            = UserStore.getApiData();
            formData.TerminalId     = UserStore.getState().selectedRegister.id;
            formData.UserId         = UserStore.getState().user.userId;
            formData.RoomId         = 0;
            formData.Dob            = this.state.dob;
            formData.Gender         = this.state.gender;
            formData.PostalCode     = this.state.postal;
            formData.CustomerTypeId = this.state.customerTypeId;
        
            AjaxPromises.POST(EndPoints.RECREATIONAL, 
                formData
            ).then(res => {
                this.setState({ loading : false });
                if (!res.Result || (res.Data && res.Data[0] && res.Data[0].ScanId === 0)) {
                    NotificationActions.error(res.Data && res.Data[0] ? res.Data[0].ScanResult : res.Message);
                } else {
                    RoutingActions.updateRoute('pos/'+res.Data[0].AcctId);
                    GuestListActions.loadGuestList();
                }
            });
        });
    }

    validate(silent) {
        var error = false;

        if (!error && !this.state.dob) {
            error = 'Date of Birth is required';
        }

        if (!error && !this.state.gender) {
            error = 'Gender is required';
        }

        if (!error && !this.state.postal) {
            error = 'Postal Code is required';
        }

        if (!error && !this.state.customerTypeId) {
            error = 'Patient Type is required';
        }

        if (!silent && error !== false) {
            NotificationActions.addNotification({
                type : 'alert',
                body : error,
            });
        }

        return !error ? true : false;
    }

    render() {
        var page = this.props.page;
        var valid = this.validate(true);

        if (page !== 'new-anon-profile') {
            return null;
        }

        return (
            <div
                className='new-profile'>

                <div className='container'>

                    <PageHeader title='Create New Anonymous Profile' />

                    <PageRow title='Date of Birth'>
                        <InputDOB tabindex="1"
                            value={this.state.dob}
                            onChange={dob => { this.setState({ dob }); }} />
                    </PageRow>

                    <PageRow title='Gender'>
                        <DropdownProfile tabindex='2'
                            field='gender'
                            options={
                            [
                                { title: '-', option: '' },
                                { title: 'Female', option: 'f' },
                                { title: 'Male', option: 'm' },
                                { title: 'Other', option: 'o' },
                                { title: 'Not Specified', option: 'x' },
                            ]}
                            selected={this.state.gender}
                            onChange={(field, gender) => { this.setState({ gender }); }} />
                    </PageRow>

                    <PageRow title='Postal Code'>
                        <Input tabindex="3"
                            required
                            value={this.state.postal}
                            onChange={postal => { this.setState({ postal }); }} />
                    </PageRow>

                    <PageRow title='Patient Type'>
                        <DD tabindex="4"
                            options={this.state.customerTypes}
                            value={this.state.customerTypeId}
                            onChange={customerTypeId => this.setState({ customerTypeId })} 
                        />
                    </PageRow>

                    <div className='row'>
                        <div className='col-12'>
                            <div tabindex="9"
                                className={'new-profile__save btn-green '+(valid ? '' : 'btn-green__disabled')}
                                onClick={this.createNewProfile}>

                                Save
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewAnonProfile;


// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/NewAnonProfile.react.jsx